import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Form from 'components/Form/FormTwoColumns';
import { NavigateNext } from '@material-ui/icons';
import ApiServices from 'services/ApiServices';
import {showMessageSuccessSimple} from 'services/SweetAlert'
import LoadingSpinner from 'components/LoadingSpinner';
import MensajeAlerta from 'components/ResponseElement'
import { useStyles } from "pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/citizenIdentityData/EmpadronarActualizar/CreateUpdateUser/style";
import { functions } from 'constants/index';

export default function FormEmpadronamientoYActualizaciones({handleClose, actualizarTabla}) {
    const classes = useStyles();
    const [loadingRequest, setLoadingRequest] = useState(false),
    [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''}),
    [open, setOpen] = useState(false);


    useEffect(() => {
        obtenerDepartamentos();
    }, []);

    // getting of the departments
    const obtenerDepartamentos =async ()=>{
        setLoadingRequest(true)
        let newElements= Object. assign({}, elements);
        try{
            let response = await ApiServices.departamentos.listRegisterCriteria();

            newElements.departamentoRegistro.list=[];
            if(response.error){
                // setCargandoDatos(false);
            }else {
                var datos = response.data
                Object.keys(datos).forEach((element, key, _array) =>{
                    if(datos[element].id === "23" || datos[element].id === "24" || datos[element].id === "25"){
                    }else{
                        newElements.departamentoRegistro.list.push({
                            id: datos[element].id,
                            name: datos[element].name,
                        });
                    }
                })
            }
        }catch(exception){
            newElements.departamentoRegistro.list=[];
        }
        setLoadingRequest(false)
        setElements(newElements);
    };


    //loading the municipalities depends of the department selected
    const obtenerMuninipios =async (event)=>{
        setLoadingRequest(true)
        let newElements = Object.assign({}, elements);
        try{
            ApiServices.municipios.searchCriteria.clear();
            ApiServices.municipios.searchCriteria.setOperator("and");
            ApiServices.municipios.searchCriteria.addEquals("departamentoId", event.target.value);
            ApiServices.municipios.setIsPublic(true);
            let response =await ApiServices.municipios.listRegisterCriteria();
            elements.municipioRegistro.value =  null;

            if (response.error){
                newElements.municipioRegistro.list=[];
            } else {
                newElements.municipioRegistro.list=response.data;
            }
        }catch(exception){
            elements.municipioRegistro.value =  null;
            newElements.municipioRegistro.list=[];
        }
        setLoadingRequest(false)
        setElements(newElements);
    };

    const [elements, setElements] = useState({
        fechaRegistro: {
            idelement: "fechaRegistro", value: new Date(), label: "Fecha de registro *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'date' ,
            disabled: false,
        },
        departamentoRegistro: {
            idelement: "departamentoRegistro", value: null, label: "Departamento *", pattern:"^[1-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], handler: obtenerMuninipios,
            disabled: false,
        },
        municipioRegistro: {
            idelement: "municipioRegistro", value: null, label: "Municipio *", pattern:"^[1-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [],
            disabled: false,
        },
        cantidadEmpadronados: {
            idelement: "cantidadEmpadronados", value: "", label: "Número de empadronados *", pattern:"^[0-9-]{1,4}$", validators: ['required'],
            errorMessages:['Número de empadronados es requerido, sin espacios al inicio y final'], isError:false, elementType:'input' ,
            disabled: false,
        },
        cantidadActualizados: {
            idelement: "cantidadActualizados", value: "", label: "Número de actualizaciones *", pattern:"^[0-9-]{1,4}$", validators: ['required'],
            errorMessages:['Número de actualizaciones es requerido,, sin espacios al inicio y final'], isError:false, elementType:'input' ,
            disabled: false,
        },
    });

    // doing the request to the api
    const guardarDatos =async (saveData)=>{
        setLoadingRequest(true)

        const dateFormat = functions.dateFormatGeneral(saveData.fechaRegistro);
        const dateSplit = dateFormat?.split('/');

        const newData = {
            ...saveData,
            fechaRegistro: `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}T06:00:00.000Z`,
            departamentoRegistro: saveData?.departamentoRegistro?.id,
            municipioRegistro: saveData?.municipioRegistro?.id
        }

        try {
            const response = await ApiServices.estadisticaDelegaciones.createRegister(newData)
            setLoadingRequest(false)
            if(response.error){
                setMensaje({tipoError:'error', tipoMensaje:'Oops!. '+ response.error ? response.error : "Existe un error, Intente de nuevo!."})
                setOpen(true)
            }else {
                showMessageSuccessSimple('Registro realizado con éxito!', response?.data?.message)
                handleClose();
                actualizarTabla()
            }
        } catch (exception) {
            setLoadingRequest(false)
            if (exception.status===404) {
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste."})
                setOpen(true)
            }
            else {
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste."})
                setOpen(true)
            }
        }
    }

    const [buttonList,setButtonList]= React.useState({
        "save":{"label":"Guardar datos","icon": <NavigateNext />,"callback":guardarDatos,"loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",
        },
        "cancel":{"label":"Cancelar","icon": <NavigateNext />,"callback": handleClose,"loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", isCancel: true
        },
    });

    // to close the modal
    const handClose = (event, reason) =>{
        if (reason === 'clickaway') {return ;}
        setOpen(false)
    }

    return (
        <div className={classes.root}>
            <br/> <br/>
            <LoadingSpinner open={loadingRequest} message="Cargando datos, Espere un momento por favor!"/>
            <div className={classes.colorComponente}>
                <Grid>
                    <Grid className={classes.marginText} item xs={12}>
                        <Form elements={elements} buttonList={buttonList}/>
                    </Grid >
                </Grid >
            </div>
            <MensajeAlerta type={mensaje.tipoError} content={mensaje.tipoMensaje} timeMessage={2000} open={open} handClose={handClose} />
        </div>
    );
}
